const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"]
const STORAGE_KEY = "tiga_signup_utm"
const VALUE_LIMIT = 255

/*
 * The signup app rewrites the URL with history.replaceState on every step
 * change, which drops the query string. Capture the campaign params on first
 * load and hold them until the final submit.
 */
export function captureUtmParams () {
	const params = new URLSearchParams(window.location.search)
	const captured = {}
	for (const key of UTM_KEYS) {
		const value = (params.get(key) || "").trim()
		if (value) {
			captured[key] = value.slice(0, VALUE_LIMIT)
		}
	}
	// Only overwrite on a campaign visit, so reloading a bare /signup part way
	// through does not wipe the attribution we already captured.
	if (Object.keys(captured).length === 0) {
		return
	}
	try {
		window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(captured))
	} catch {
		// sessionStorage is blocked; attribution is optional, signup is not
	}
}

export function storedUtmParams () {
	try {
		const stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY))
		if (!stored || typeof stored !== "object" || Array.isArray(stored)) {
			return {}
		}
		return stored
	} catch {
		return {}
	}
}
